import PropTypes from "prop-types"
import SetPassword from "modules/set-password"

function ResetPassword({ token, mfaEnabled, passwordExpired }) {
  return <SetPassword
    title="Reset your password"
    text="Almost done, just enter your new password below."
    buttonText="Reset Password & Log in"
    token={token}
    mfaEnabled={mfaEnabled}
    passwordExpired={passwordExpired}
  />
}

ResetPassword.propTypes = {
  token: PropTypes.string.isRequired,
  mfaEnabled: PropTypes.bool.isRequired,
  passwordExpired: PropTypes.bool.isRequired,
}

export default ResetPassword
